import { apiFetch } from './client';
import type { HandListItem } from '../types/mjai';

export async function listFavorites(params?: { page?: number; page_size?: number }): Promise<HandListItem[]> {
  const q = new URLSearchParams();
  if (params?.page) q.set('page', String(params.page));
  if (params?.page_size) q.set('page_size', String(params.page_size));
  return apiFetch(`/favorites?${q}`);
}

export async function checkFavorite(hand_id: string): Promise<{ is_favorited: boolean }> {
  return apiFetch(`/favorites/${hand_id}/check`);
}

export async function addFavorite(hand_id: string): Promise<void> {
  await apiFetch(`/favorites/${hand_id}`, { method: 'POST' });
}

export async function removeFavorite(hand_id: string): Promise<void> {
  await apiFetch(`/favorites/${hand_id}`, { method: 'DELETE' });
}
